"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jquery = _interopRequireDefault(require("jquery"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _index = _interopRequireDefault(require("../editTagBtn/index.js"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _index2 = _interopRequireDefault(require("../inlineTagAdd/index.js"));
var _index3 = require("../../public/cccisd-scope-manager/index.js");
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _index4 = _interopRequireDefault(require("../addTagBtn/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var TagTable = /*#__PURE__*/function (_React$Component) {
  _inherits(TagTable, _React$Component);
  function TagTable() {
    var _this;
    _classCallCheck(this, TagTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TagTable, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {});
    _defineProperty(_assertThisInitialized(_this), "getScopes", function () {
      // this.setState({
      //     loading: true,
      // });
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'GET',
        url: Boilerplate.route('poly.api.v1.scope.index'),
        data: {
          _token: Boilerplate.settings.csrfToken
        },
        dataType: 'json',
        success: function success(data) {
          $this.setState({
            scopes: data
            // scope: _first(_filter(data, function(s){return s.id == $this.props.scope;})),
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "notifyThenUpdate", function (message) {
      // this.refs.AddTagBtn.refs.CreateTag.close();
      (0, _cccisdNotification["default"])({
        message: message,
        type: 'success',
        // can be 'success', 'info', 'warning', 'danger'
        duration: 8000 // time in milliseconds. 0 means infinite
      });
      _this.getScopeTags();
    });
    _defineProperty(_assertThisInitialized(_this), "AddTag", function (values) {
      _this.props.onLoadStart();
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'POST',
        url: Boilerplate.route('poly.api.v1.tag.store'),
        data: Object.assign(values, {
          _token: Boilerplate.settings.csrfToken,
          scope: $this.props.scope
        }),
        dataType: 'json',
        success: function success(data) {
          $this.notifyThenUpdate('New Tag ' + values.internal_name + ' Created');
          $this.props.reset('InlineTagAdd');
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getScopeTags", function () {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'GET',
        url: Boilerplate.route('poly.api.v1.tag.tagsForScope').replace('{scope}', $this.props.scope),
        data: {
          _token: Boilerplate.settings.csrfToken
        },
        dataType: 'json',
        success: function success(data) {
          $this.setState({
            tags: data
          });
          $this.props.onLoadComplete();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getScope", function () {
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'GET',
        url: Boilerplate.route('poly.api.v1.scope.show').replace('{scope}', $this.props.scope),
        data: {
          _token: Boilerplate.settings.csrfToken
        },
        dataType: 'json',
        success: function success(data) {
          $this.setState({
            scope: data.data
          });
          $this.props.onLoadComplete();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "deleteTag", function (id) {
      _this.props.onLoadStart();
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'DELETE',
        url: Boilerplate.route('poly.api.v1.tag.destroy').replace('{tag}', id),
        data: {
          _token: Boilerplate.settings.csrfToken
        },
        dataType: 'json',
        success: function success() {
          $this.notifyThenUpdate('Tag ' + (0, _first2["default"])((0, _filter2["default"])($this.state.tags, function (t) {
            return t.id === id;
          })).name + ' Deleted');
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getDeleteBtn", function (id) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: "glyphicon glyphicon-remove"
        }),
        className: "btn btn-danger tableBtn",
        isConfirm: true,
        confirmationMessage: 'Are you sure you want to delete this tag: ' + (0, _filter2["default"])(_this.state.tags, function (o) {
          return o.id === id;
        })[0].name + '?',
        onClick: _this.deleteTag.bind(null, id),
        isDisabled: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updateTag", function (id, values) {
      _this.props.onLoadStart();
      var $this = _assertThisInitialized(_this);
      _jquery["default"].ajax({
        type: 'PUT',
        url: Boilerplate.route('poly.api.v1.tag.update').replace('{tag}', id),
        data: Object.assign(values, {
          _token: Boilerplate.settings.csrfToken
        }),
        dataType: 'json',
        success: function success(data) {
          $this.notifyThenUpdate('Tag ' + values.name + ' Updated');
        }
      });
    });
    return _this;
  }
  _createClass(TagTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      localStorage.setItem('selectedScope', this.props.scope);
      this.getScopes();
      this.getScopeTags();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scope !== this.props.scope) {
        this.getScopeTags();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var columns = [{
        name: 'name',
        label: 'Name',
        "class": 'text-left'
      }, {
        name: 'internal_name',
        label: 'Internal Name',
        "class": 'text-left'
      }, {
        name: 'actions',
        label: 'Actions',
        "class": 'text-center',
        render: function render(value, row) {
          var deleteBtn = _this2._getDeleteBtn(row.id);
          return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_index["default"], {
            ref: "EditBtn",
            onSuccess: _this2.updateTag.bind(null, row.id),
            initialValues: row
          }), ' ', deleteBtn);
        }
      }];

      // if you want to have the casing affect the sort remove .toLowerCase()
      if (this.state.tags) {
        this.state.tags.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          return 0;
        });
      }
      var dropdown;
      if (this.props.showScopeDropdown) {
        dropdown = /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-md-12",
          style: {
            padding: '0'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-md-2"
        }, /*#__PURE__*/_react["default"].createElement(_index3.ScopeSelector, _extends({
          showHomeBtn: true,
          label: "Scope:",
          scope: this.props.scope
        }, this.props, {
          scopes: this.state.scopes || []
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-md-10"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textAlign: 'right'
          }
        }, /*#__PURE__*/_react["default"].createElement(_index4["default"], {
          ref: "AddTagBtn",
          onSuccess: this.AddTag
        })))));
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, dropdown, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-12"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        ref: "Table",
        data: this.state.tags,
        columns: columns,
        orderBy: "name",
        isAscentOrder: true
      }), /*#__PURE__*/_react["default"].createElement(_index2["default"], {
        ref: "InlineTagAdd",
        onSubmit: this.AddTag
      }))));
    }
  }]);
  return TagTable;
}(_react["default"].Component);
_defineProperty(TagTable, "propTypes", {
  scope: _propTypes["default"].string,
  onLoadComplete: _propTypes["default"].func,
  onLoadStart: _propTypes["default"].func,
  reset: _propTypes["default"].func
});
_defineProperty(TagTable, "defaultProps", {
  scope: {},
  onLoadStart: function onLoadStart() {},
  onLoadComplete: function onLoadComplete() {}
});
var _default = exports["default"] = (0, _reactRedux.connect)(null, {
  reset: _reduxForm.reset
})(TagTable);